<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'Users',
}

</script>



// WEBPACK FOOTER //
// src/components/users/Users.vue